import { render } from 'inferno';
import './index.css';
import App from './containers/App';

render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js